import { useState } from 'react';
import { ArrowRight, Loader2 } from 'lucide-react';
import { digitalApi, errMsg, formatPrice } from '@/lib/digitalApi';

const fieldCls = 'w-full bg-transparent border-b border-taupe/40 py-3 text-matte placeholder:text-matte/40 focus:outline-none focus:border-gold transition-colors';

export const BuyerForm = ({ product, onClaimed }) => {
  const [form, setForm] = useState({ first_name: '', email: '', founders_list_opt_in: false, website: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      if (product.is_free) {
        onClaimed(await digitalApi.claim(product.slug, form));
      } else {
        const { checkout_url: url } = await digitalApi.checkout(product.slug, form);
        window.location.href = url;
        return;
      }
    } catch (err) {
      setError(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="digital-buyer-form">
      <input name="website" value={form.website} onChange={set('website')} tabIndex={-1} autoComplete="off" className="hidden" aria-hidden />
      <input required maxLength={80} placeholder="First name" value={form.first_name} onChange={set('first_name')} className={fieldCls} data-testid="digital-buyer-first-name" />
      <input required type="email" placeholder="your@email.com" value={form.email} onChange={set('email')} className={fieldCls} data-testid="digital-buyer-email" />
      <label className="flex items-start gap-3 pt-2 cursor-pointer text-[13px] text-matte/70 leading-relaxed">
        <input
          type="checkbox"
          checked={form.founders_list_opt_in}
          onChange={set('founders_list_opt_in')}
          className="mt-1 w-4 h-4 accent-[#C8A15A]"
          data-testid="digital-buyer-founders-list-optin"
        />
        <span>Also join The Founder&rsquo;s List, a five-minute behind-the-scenes email every Friday. Optional, unsubscribe anytime.</span>
      </label>
      {error && <p className="text-red-700 text-sm" data-testid="digital-buyer-error">{error}</p>}
      <button type="submit" disabled={busy} className="btn-primary w-full sm:w-auto justify-center disabled:opacity-60" data-testid="digital-buyer-submit">
        {busy ? <Loader2 size={14} className="animate-spin" /> : null}
        {product.is_free ? 'Get Free Download' : `Purchase · ${formatPrice(product.price_cents, false)}`}
        {!busy && <ArrowRight size={14} strokeWidth={1.6} />}
      </button>
      <p className="text-[11px] text-matte/45 leading-relaxed">
        {product.is_free
          ? 'Your download starts here, and a copy of the link is sent to your email.'
          : 'Secure checkout by Stripe. Your download link appears right after payment and is emailed to you.'}
      </p>
    </form>
  );
};
